import './scripts/modernizr';
import navigation from './scripts/components/navigation';
import footer from './scripts/components/footer';
import animatedSections from './scripts/components/animatedSections';
import gradientTracking from './scripts/components/gradientTracking';
import tables from './scripts/components/tables';
import wpBlocks from './scripts/components/wpBlocks';
import accordion from '@blocks/accordion';
import modalControls from '@blocks/modal';
import greenhouseAPI from '@blocks/job-listings-greenhouse-api';
import signInForms from '@blocks/sign-in-form';
import searchableList from '@blocks/searchable-list';
import contactForm from '@blocks/contact-form';
import callsToAction from '@blocks/calls-to-action';
import tabbedContent from '@blocks/tabbed-content';
import fiftyFiftyCardCarousel from '@blocks/50-50-card-carousel';
import trialLocations from '@blocks/trial-locations';

declare global {
  interface Window {
    gmak: string; // gmak - Google Maps API Key
    initGoogleMaps: () => void;
    Sentry?: {
      captureException: (e: Error) => void;
    };
  }
}

// Imported Functions

export const docReady: (fn: () => void) => void = (fn) => {
  // see if DOM is already available
  if (
    document.readyState === 'complete' ||
    document.readyState === 'interactive'
  ) {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

docReady(() => {
  [
    wpBlocks,
    navigation,
    footer,
    accordion,
    modalControls,
    gradientTracking,
    animatedSections,
    tables,
    greenhouseAPI,
    signInForms,
    searchableList,
    contactForm,
    callsToAction,
    tabbedContent,
    fiftyFiftyCardCarousel,
    trialLocations,
  ].forEach((fn) => {
    try {
      fn();
    } catch (e) {
      console.error(e);
      try {
        if (
          typeof window.Sentry === 'object' &&
          typeof window.Sentry.captureException === 'function'
        ) {
          window.Sentry.captureException(e);
        }
      } catch (_e) {
        console.error('Failed to send error to Sentry');
        console.error(_e);
      }
    }
  });
});
